// @flow
import React from 'react'
import PasswordResetForm from './form'
import { useOutletContext } from 'react-router-dom'

const PasswordReset = (): any => {
  const { auth } = useOutletContext()

  return (
    <div className='pw-reset-email'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Forgot your password?</h3>
        <h4 className='login__subtitle'>Submit your email address to start the recovery process.</h4>
      </div>
      <PasswordResetForm auth={auth} />
    </div>
  )
}

PasswordReset.displayName = 'PasswordReset'

export default PasswordReset
